export default '/static/frontend/ReachDigital/12gobiking/dist/assets/iban-nl-39bea9b0.png'